<template lang="pug">
//- MEMO:
  - vgt関連の機能
  - 学割設定
  については、現在使用しておらずデザインの確認ができないため削除。
  使用を再開するタイミングで追加してください。
div
  .eventshow-status-close(v-if="!event.entryable")
    | 受付は終了しました
  .eventshow-status-open(v-else)
    | 参加者受付中
  .eventshow-drawing(v-if="event.drawing && isNotWinning")
    .eventshow-drawing-ttl
      nuxt-link(:to="event.detail_url")
        | {{ event.name }}
  .eventshow-info(v-else)
    .eventshow-info-thumb
      img(v-lazy="event.cover_image.ogp_1200.url" :alt="event.name")
    .eventshow-info-txt
      .ttl
        a(:href="event.detail_url")
          | {{ event.name }}
      ul
        li
          icon-calendar-svg
          | {{ event.period }}
        li
          icon-place-svg
          | {{ event.place }}
        li
          icon-pay-svg
          client-only
            //- Premium限定イベント
            template(v-if="event.premium_only")
              .price(v-html="priceTxt(event.premium_entry_fee)")
              .limited （Premium会員のみ参加可能）
              template(v-if="!$auth.loggedIn || $auth.user.status === 'free'")
                br
                .premium-link
                  nuxt-link(to="/setting/billing") ※Vook Premium(年額払い 1,665円/月)とは？
            //- キャリア限定イベント
            template(v-else-if="event.event_type === 'career'")
              .price(v-html="priceTxt(event.entry_fee)")
              .limited （Vookキャリアユーザーのみ参加可能）
            //- 通常イベント
            .eventshow-info-txt-price(v-else)
              strong
                | 通常価格
              .price(v-html="priceTxt(event.entry_fee)")
              template(v-if="event.premium_entry_fee != null")
                strong
                  | Premium会員
                .price(v-html="priceTxt(event.premium_entry_fee)")
                template(v-if="!$auth.loggedIn || $auth.user.status === 'free'")
                  .premium-link
                    nuxt-link(to="/setting/billing") ※Vook Premium(年額払い 1,665円/月)とは？
    .eventshow-info-ticket(v-if="($route.query.referer === 'mypage' || !event.vgt_day2) && event.applied")
      .eventshow-info-ticket-dot
        .eventshow-info-ticket-info
          h2
            | {{ `#${event.entry.entry_number}` }}
          h3
            | {{ event.entry.last_name }}
            | &nbsp;
            | {{ event.entry.first_name }}
        .eventshow-info-ticket-barcode
          img(v-lazy="require('~/assets/images/events/show/barcode.png')")
          | {{ barcodeNumber }}
  .eventshow-description(v-if="event.description" style="white-space: pre-line;" v-html="event.description")
</template>

<script>
import RemainingLabel from '~/components/events/RemainingLabel'
import dayjs from '~/libs/dayjs'
import IconCalendarSvg from '~/assets/images/svg/icon_calendar.svg?inline'
import IconPlaceSvg from '~/assets/images/svg/icon_place.svg?inline'
import IconPeopleSvg from '~/assets/images/svg/icon_people.svg?inline'
import IconPaySvg from '~/assets/images/svg/icon_pay.svg?inline'

export default {
  components: {
    RemainingLabel,
    IconCalendarSvg,
    IconPlaceSvg,
    IconPeopleSvg,
    IconPaySvg
  },
  props: {
    event: {
      type: Object,
      required: true
    }
  },
  computed: {
    priceTxt() {
      return (fee) => {
        if (fee) {
          return `${fee.toLocaleString()}円<div class="price-zei">(税込)</div>`
        } else {
          return '無料'
        }
      }
    },
    barcodeNumber() {
      if (this.event.entry) {
        return (
          dayjs(this.event.begin_at).format('YYMMDD') +
          this.event.entry.entry_number
        )
      } else {
        return null
      }
    },
    isNotWinning() {
      if (this.event.entry) {
        return this.event.entry?.drawing_state !== 'winning'
      }
      return false
    }
  }
}
</script>
<style lang="scss" scoped>
::v-deep {
  .eventshow-status {
    &-close,
    &-open {
      padding: 10px 15px;
      color: #fff;
      font-weight: bold;
      display: table;
      font-size: 18px;
      margin-bottom: 20px;
      @include media(sp) {
        margin-bottom: 10px;
      }
    }
    &-close {
      background: #999;
    }
    &-open {
      background: $pink;
    }
  }
  .eventshow-drawing {
    padding-bottom: 30px;
    @include media(sp) {
      padding: 10px 10px 20px;
    }
    &-ttl {
      line-height: 1.5;
      @include media(pc) {
        text-align: center;
        font-size: 30px;
      }
      @include media(sp) {
        font-size: 20px;
      }
      a {
        font-weight: bold;
      }
    }
  }
  .eventshow-info {
    @include boxshadow($size: 13px);
    border-radius: $radius;
    background: #fff;
    margin: 0 auto 40px;
    @include media(pc) {
      display: flex;
      width: 100%;
    }
    @include media(sp) {
      max-width: 370px;
      width: calc(100vw - 20px);
      margin: 10px auto;
      border: 1px solid #eee;
    }
    &-thumb {
      width: 600px;
      line-height: 0;
      @include media(pc) {
        align-self: center;
        border-radius: $radius 0 0 $radius;
        overflow: hidden;
      }
      @include media(sp) {
        width: 100%;
      }
    }
    &-txt {
      padding: 20px 40px;
      position: relative;
      @include media(pc) {
        flex: 1;
        align-self: center;
      }
      @include media(sp) {
        padding: 30px 30px 30px 25px;
        display: block;
      }
      .ttl {
        margin-bottom: 10px;
        line-height: 1.5;
        font-weight: bold;
        font-size: 20px;
        @include media(sp) {
          font-size: 16px;
        }
      }
      ul {
        padding: 10px 7px 10px 0;
      }
      li {
        position: relative;
        padding: 10px 0 10px 32px;
        line-height: 21px;
        font-size: 15px;
      }
      li + li {
        border-top: 1px solid #eee;
      }
      svg {
        position: absolute;
        top: 8px;
        left: 0;
        width: 25px;
        height: 25px;
        fill: none;
        stroke: $violet;
      }
      &-price {
        display: grid;
        grid-template-columns: auto 1fr;
        column-gap: 15px;
      }
      .price {
        display: inline-block;
        white-space: nowrap;
        &-zei {
          display: inline;
          padding-left: 3px;
          font-size: 0.8em;
          color: $font_color_light;
        }
      }
      .limited {
        display: inline-block;
        font-weight: bold;
        color: $red;
      }
      .premium-link {
        grid-column: 1/3;
        margin-top: 5px;
        a {
          display: inline-block;
          padding: 5px;
          border-radius: $radius;
          background: $light_violet;
          line-height: 1.5;
          text-decoration: none;
          color: $violet;
          font-size: 12px;
          &:hover {
            text-decoration: underline;
          }
        }
      }
      @include media(sp) {
        h3 {
          top: 5px;
          left: 5px;
        }
        ul {
          padding: 0;
        }
      }
    }
    &-ticket {
      @include gradation();
      width: 173px;
      color: #fff;
      position: relative;
      display: table-cell;
      vertical-align: top;
      padding: 20px 20px 20px 25px;
      @include media(pc) {
        border-radius: 0 $radius $radius 0;
      }
      &::before,
      &::after {
        content: '';
        background: $light_gray;
        width: 26px;
        height: 26px;
        border-radius: 100px;
        position: absolute;
        left: -8px;
        z-index: 2;
      }
      &::before {
        top: -13px;
      }
      &::after {
        bottom: -13px;
      }
      &-dot {
        &::before {
          position: absolute;
          z-index: 1;
          left: 5px;
          top: 0;
          content: '';
          background: url(~assets/images/events/show/ticket-bg-y.png) repeat-y;
          background-size: 1px 4px;
          width: 1px;
          height: 100%;
        }
      }
      h2 {
        font-size: 30px;
        font-weight: bold;
      }
      h3 {
        font-size: 15px;
      }
      &-barcode {
        position: absolute;
        width: calc(100% - 45px);
        margin: 20px 20px 20px 25px;
        bottom: 0;
        left: 0;
        background: #fff;
        color: $font_color_base;
        text-align: center;
        padding: 8px;
        font-size: 11px;
        line-height: 1;
        img {
          width: 117px;
          display: block;
          margin-bottom: 5px;
        }
      }
      @include media(sp) {
        width: 100%;
        display: block;
        padding: 25px 20px 20px;
        &::before,
        &::after {
          left: auto;
          top: -8px;
        }
        &::before {
          left: -13px;
        }
        &::after {
          right: -13px;
          bottom: auto;
        }
        &-dot {
          display: flex;
          justify-content: space-between;
          &::before {
            left: 0;
            top: 5px;
            background: url(~assets/images/events/show/ticket-bg-x.png) repeat-x;
            background-size: 4px 1px;
            width: 100%;
            height: 1px;
          }
        }
        &-barcode {
          position: relative;
          width: auto;
          margin: 0;
          img {
            width: 90px;
          }
        }
      }
    }
  }
  .eventshow-description {
    border: 1px solid $red;
    font-size: 14px;
    background: #fff;
    padding: 20px;
    margin-bottom: 40px;
    line-height: 1.5;
    border-radius: $radius;
    @include media(sp) {
      margin: 0 $edge_padding-responsive 20px $edge_padding-responsive;
    }
  }
}
</style>
